
import {WooComm} from "../../woocommerce/index";
import { FilterType, isStaticFilter } from '../@types/Filters'
import Vue from "vue/dist/vue.common";


export const Actions = {
    addFilter({commit}, payload) {
      let mutationPayload = {
        type: 'ADD_FILTER',
        filter: payload
      }
        if (payload.hasOwnProperty('filter')) {
          mutationPayload['filter'] = payload.filter
          mutationPayload['type'] = !!payload.suppress ? 'ADD_FILTER_QUIET': 'ADD_FILTER'
        }

        commit(mutationPayload)
    },
    removeFilterQuiet(context, payload) {
      context.commit('REMOVE_FILTER_QUIET', payload)
    },
    removeFilter : (context, payload) => {
        context.commit('REMOVE_FILTER', payload);
    },
    clearFilters(context, quiet = false) {
      context.commit(!quiet ? 'CLEAR_FILTERS' : 'CLEAR_FILTERS_QUIET')
    },
    updateProducts : (context) => {
        context.commit('UPDATE_PRODUCTS');
    },
    clearProducts : (context) => {
        context.commit('CLEAR_PRODUCTS');
    },
    addProductTableData : (context, payload) => {
        context.commit('updateProductTableData', payload);
    },
    searchProducts : (context, payload) => {
        if (payload == "") {
            context.commit('UPDATE_PRODUCTS', []);
        } else {
            let query = {search : payload};
            query.lang = context.state.lang

            WooComm.getProducts(query, response => {
                context.commit('UPDATE_PRODUCTS', response);
            });
        }        
    },
    filterProducts : (context) => {
        Vue.set(context.state, 'isUpdatingProducts', true);
        context.dispatch('getProductQueryArgs')
               .then((query) => {
                    WooComm.getProducts(query, (response) => {
                      context.commit('UPDATE_PRODUCTS', response)
                    })                   
               });
    },
    loadCategories : (context) => {  
        WooComm.getCategories({
          lang: context.state.lang
        }, response => { context.commit('SET_CATEGORIES', response)}) ;    
    },
    loadProducts : (context, filters = {}) => {
        WooComm.getProducts(filters, (response) => {context.commit('SET_PRODUCTS', response)});
    },
    loadAttributes : (context) => {
        WooComm.getAttributes({lang: context.state.lang}, (attributes) => {
            context.commit('SET_ATTRIBUTES', attributes)
            attributes.forEach(attribute => {
                if (attribute.slug != 'pa_size' && attribute.slug != 'pa_us-or-eu') {
                    context.dispatch('loadAttributeTerms', attribute.id);
                }                
            }) 
                       
        });
    },
    loadAttributeTerms : (context, attributeId) => {
        WooComm.getAttributeTerms(attributeId, {lang: context.state.lang}, (terms) => { 
            context.commit({
                type : 'ADD_ATTRIBUTE_TERMS', 
                attribute : attributeId,
                terms : terms
            }); 
        })
    },
    getProductQueryArgs : (context) => {
        let query = {lang: context.state.lang};
        let filters = context.getters.getFilters;
        if (filters.length > 0) {
            filters.forEach((term, i) => {
                if (term.type === FilterType.Meta) {
                  if (!query.hasOwnProperty('meta')) {
                    query['meta'] = []
                  }

                  if (term.handle === 'parent') {
                    query['parent'] = term.value
                  } else {
                    query.meta.push({
                        meta_key: term.handle,
                        meta_value: term.value
                    })
                  }
                } else if (term.type === FilterType.Taxonomy) {
                  if (!query.hasOwnProperty(term.handle)) {
                    query[term.handle] = term.value
                  }
                }
            });
        }
        
        return query;
    },
    resetCountdownTimer: (context) => {
        context.commit('SET_COUNTDOWN_TIMER_STARTED', false)
        context.commit('SET_COUNTDOWN_TIMER', 0)
    },
    loadProductPage(context, pageNum) {
      Vue.set(context.state, 'isUpdatingProducts', true)
      context
        .dispatch('getProductQueryArgs')
        .then(query => {
          query['paged'] = pageNum

          return query
        })
        .then(query => {
          WooComm.getProducts(query, (response) => {
            context.commit('UPDATE_PRODUCTS', response)
          })
        })
    },
    updateCategories({commit, getters, state}) {
      let filters = getters.getFilters
      let args = {
        filters: filters.filter(filter => isStaticFilter(filter)),
        lang: state.lang
      }
      WooComm.updateCategories(args, (response) => {
        commit('SET_CATEGORIES', response.categories)
      })
    }
}